import {useStore} from '@/store/root-store';
import {opaqueColor} from '@/utils/colors';
import {Button, Divider} from 'antd';
import {observer} from 'mobx-react';
import styled from 'styled-components';
import {faCircleCheck, faCircleX, faCircleDashed, faArrowLeft, faArrowRight} from '@fortawesome/pro-duotone-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {toJS} from 'mobx';
import {useEffect, useState} from 'react';

interface SingleTermProps {
  term: any;
  finalTermsList: any;
  setFinalTermsList: any;
  key: any;
  setVisible: any;
  kwUpdate: any;
}

export const SingleTerm = observer(({term, finalTermsList, setFinalTermsList, setVisible, kwUpdate}: SingleTermProps) => {
  const [termIndex, setTermIndex] = useState(0);
  const {
    contentOptimizer: {
      currentPage: {
        getstagingLinkSuggestions,
        setStagingLinkSuggestions,
        setLinkActiveTerm,
        linkActiveTerm,
        highlightedNodeId,
      },
    }} = useStore('');

  useEffect(()=>{
    setTermIndex(0);
  }, [kwUpdate, linkActiveTerm]);

  const onTermClickHandler = curTerm => {
    const newClass = curTerm?.replaceAll(' ', '-');
    const totalOccurances = document.getElementsByClassName(newClass)?.length;
    const updatedValues = {
      class: curTerm.replaceAll(' ', '-')+`${term[0]?.itemIndex}`,
      term: curTerm,
      order: linkActiveTerm?.order < totalOccurances - 1 ? linkActiveTerm.order : 0,
      itemIndex: term[0].itemIndex,
    };

    setLinkActiveTerm(updatedValues);
  };

  const acceptLink = (e:any) => {
    e.stopPropagation();
    const newItems = [...term];
    newItems[termIndex].status = 'accepted';
    const updateTerm = finalTermsList.map((val:any)=> val.filter((value:any)=> value.itemIndex == term[termIndex].itemIndex).length > 0 ? newItems : val);
    term?.status !== 'dismissed' && setFinalTermsList([...updateTerm]);
    onBlockStatusChange('accept');
  };

  const dismissLink = (e:any) => {
    e.stopPropagation();
    const newItems = [...term];
    newItems[termIndex].status = term[termIndex].status == 'default'? 'dismissed' : 'default';
    const updateTerm = finalTermsList.map((val:any)=> val.filter((value:any)=> value.itemIndex == term[termIndex].itemIndex).length > 0 ? newItems : val);
    setFinalTermsList([...updateTerm]);
    onBlockStatusChange(term[termIndex]?.status == 'dismissed' ? 'dismiss' : 'undo');
  };

  const onArrowClickHandler = (e, direction: 'next' | 'prev') => {
    e.stopPropagation();
    const incDec = direction == 'next' ? true : false;
    const updatedValues = {
      class: term[incDec ? termIndex+1 : termIndex-1]?.suggestion[0]?.keyword?.replaceAll(' ', '-')+`${term[incDec ? termIndex+1 : termIndex-1]?.itemIndex}`,
      term: term[incDec ? termIndex+1 : termIndex-1]?.suggestion[0]?.keyword,
      order: direction == 'next' ? linkActiveTerm?.order + 1 : linkActiveTerm?.order - 1,
      itemIndex: term[incDec ? termIndex+1 : termIndex-1]?.itemIndex,
    };
    setLinkActiveTerm(updatedValues);
    direction == 'next' ? setTermIndex(termIndex+1) : setTermIndex(termIndex-1);
  };

  const onBlockStatusChange = (action: 'accept' | 'dismiss' | 'undo') => {
    let prepDataArr = toJS(getstagingLinkSuggestions);
    prepDataArr = prepDataArr?.map(item => {
      if (item.itemIndex == highlightedNodeId) {
        return {
          ...item,
          ...(action == 'accept' && {status: 'accepted'}),
          ...(action == 'dismiss' && {status: 'dismissed'}),
          ...(action == 'undo' && {status: 'default'}),
        };
      } else {
        return item;
      }
    });
    setStagingLinkSuggestions(prepDataArr);
  };

  if (!term?.filter((item:any)=> item?.suggestion?.length > 0)) return;

  const cardClick = (e:any) => {
    e.preventDefault();
    setVisible(false);
    setTermIndex(0);
    onTermClickHandler(term[0]?.suggestion[0]?.keyword);
  };

  const scrollTerms = (e, index) => {
    e.stopPropagation();
    const updatedValues = {
      class: term[index]?.suggestion[0]?.keyword?.replaceAll(' ', '-')+`${term[index]?.itemIndex}`,
      term: term[index]?.suggestion[0]?.keyword,
      order: index < termIndex ? linkActiveTerm?.order - 1 : linkActiveTerm?.order + 1,
      itemIndex: term[index]?.itemIndex,
    };
    setLinkActiveTerm(updatedValues);
    setTermIndex(index);
  };

  const acceptedStatus = term?.filter((item:any) => item.status == 'accepted')?.length;
  const dismissedStatus = term?.filter((item:any) => item.status == 'dismissed')?.length;

  return <Container >
    <CardTitle onClick={(e:any) => {
      const value = term?.filter((isTerm:any)=> linkActiveTerm?.itemIndex == isTerm?.itemIndex)?.length;
      !( value > 0) && cardClick(e);
    }}>
      <div><FontAwesomeIcon color={acceptedStatus > 0 ? 'green' : dismissedStatus == term?.length ? 'red' : 'lightgray'}
        icon={acceptedStatus > 0 ? faCircleCheck : dismissedStatus == term?.length ? faCircleX : faCircleDashed} fontSize={14}/>
      {acceptedStatus > 0 ?
        <StatusTitle><span>Accepted {acceptedStatus}</span>: {term?.filter((item:any) => item.status == 'accepted').map((val:any)=> val.suggestion[0].keyword).join(', ')} </StatusTitle> :
        dismissedStatus == term?.length ?
          <StatusTitle>All Dismissed</StatusTitle> :
          <StatusTitle>Review {term?.filter((item:any)=> item?.status !== 'dismissed' && item?.status !== 'accepted')?.length} suggestion</StatusTitle>}
      </div>
      <p className='termName'>{term[0]?.title}</p>
      <p className='termLink'>{term[0].link}</p>
    </CardTitle>
    {(term?.filter((isTerm:any)=> linkActiveTerm?.itemIndex == isTerm?.itemIndex)?.length > 0 && term?.filter((isVal:any)=> linkActiveTerm.term == isVal?.suggestion[0]?.keyword)?.length > 0) &&
    <>
      <DividerLine/>
      <SuggestionCard>
        <p className='termsuggestion'>Suggestion {termIndex+1} of {term?.length}</p>
        <p className='termKeyword'>{linkActiveTerm?.term}</p>
        <div className='actionTerm'>
          <div>
            <Button disabled={term[termIndex]?.status == 'accepted' || term[termIndex]?.status == 'dismissed'} className={`acceptBtn ${term[termIndex]?.status == 'accepted' ? 'acceptCol' : term[termIndex]?.status == 'dismissed' ? 'dismissCol' : ''}`} onClick={acceptLink}>
              {term[termIndex]?.status == 'default' ? 'Accept' : term[termIndex]?.status == 'accepted' ? 'Accepted' : 'Dismissed'}
            </Button>
            <Button className={`dismissBtn`} onClick={dismissLink}>{term[termIndex]?.status == 'dismissed' ? 'Undo' : 'Dismiss'}</Button>
          </div>
          {term?.length > 1 && <div style={{justifyContent: 'end', width: '44%', display: 'flex', alignItems: 'center'}}>
            <DotsContainer>
              {term?.map((suggestion, idx) => {
                return <Dot onClick={(e:any)=> scrollTerms(e, idx)} color={suggestion.status == 'default' ? '#A3A4A4' : suggestion.status == 'dismissed' ? '#F44343' : '#1FAC47'} key={idx} isActive={highlightedNodeId == suggestion.itemIndex}/>;
              })}
            </DotsContainer>
            <Button disabled={termIndex == 0} onClick={(e:any)=>onArrowClickHandler(e, 'prev')} className='previous'><FontAwesomeIcon icon={faArrowLeft} fontSize={14} style={{marginLeft: '-5px'}} /></Button>
            <Button disabled={termIndex+1 == term?.length} onClick={(e:any)=>onArrowClickHandler(e, 'next')} className='forward'><FontAwesomeIcon icon={faArrowRight} fontSize={14}style={{marginLeft: '-5px'}} /></Button>
          </div>}
        </div>
      </SuggestionCard> </>
    }
  </Container>;
});

const Container = styled.div`
  width: 100%;
  padding: 8px 16px;
  margin-top: 4px;
  margin-bottom: 4px;
  background-color: white;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,0.2);
  transition: background .3s ease-in;
  // display: flex;

  .acceptBtn{
    background-color: rgba(42, 193, 85, 1);
    border: none;
    margin-right: 10px;
    border-radius: 8px;
    color: white;
  }
  .acceptCol{
    color: rgba(42, 193, 85, 1) !important;
    background-color: rgb(42 193 85 / 53%) !important;
  }
  .dismissCol{
    color: red !important;
    background-color: #ff000069 !important;
  }
  .dismissBtn{
    background-color: rgba(242, 242, 245, 1);
    border: none;
    margin-right: 10px;
    border-radius: 8px;
    span{
      color: black;
    }
  }
  .previous, .forward {
    border-radius: 6px;
    background-color: rgba(242, 242, 245, 1);
    height: 32px;
    width: 33px;
    margin-left: 10px;
    .svg{
      margin-left: -5px !important;
    }
  }
  .termName { 
    margin: 0px;
    text-overflow: ellipsis;
    overflow: hidden;
    text-wrap: nowrap;
    font-weight: 600;
    font-size: 14px;
  }
  .termLink{
    font-size: 12px;
    color: rgba(45, 108, 202, 1);
    word-break: break-all;
  }
  .termKeyword{
    margin: 0px;
    font-weight: 500;
    text-overflow: ellipsis;
    overflow: hidden;
    text-wrap: nowrap;
  }
  .termsuggestion{
    font-size: 12px;
    color: rgba(78, 81, 86, 1);
    margin: 0px;
  }

  &.isActive {
    background: linear-gradient(90.16deg, ${opaqueColor('#E15E83', 20)} 2.81%, ${opaqueColor('#F58069', 20)} 96.58%);

    .termName {
      background: linear-gradient(90.16deg, #E15E83 2.81%, #F58069 96.58%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  
  &:hover {
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  }
`;


const DotsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: 2%;
  margin-top: 3px;
}
  // flex-direction: row-reverse;
`;

const Dot = styled.div<{color: string; isActive: boolean}>`
  width: 7px;
  height: 7px;
  margin-right: 5px;
  margin-bottom: 5px;
  border-radius: 100%;
  background-color: ${p => p.color};
  position: relative;

  &::after {
    content: '';
    display: ${p => p.isActive ? 'block' : 'none'};
    width: 11px;
    height: 11px;
    border-radius: 100%;
    position: absolute;
    top: -2px;
    left: -2px;
    background-color: transparent;
    border: 1px solid red;
  }
`;

const CardTitle = styled.div`
width: 100%;
`;

const StatusTitle = styled.span`
margin-left: 10px;
span{
  color: green;
}
`;

const DividerLine = styled(Divider)`
background-color: lightgray;
margin-top: 0;
margin-bottom: 12px;
`;

const SuggestionCard = styled.div`
width: 100%;
.actionTerm{
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 10px;
}
`;
